<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <v-icon
        x-small
        class="ml-1"
        v-bind="attrs"
        v-on="on"
      >
        mdi-help-circle-outline
      </v-icon>
    </template>
    <p
      class="pt-2"
      style="max-width: 250px"
    >
      <slot />
    </p>
  </v-tooltip>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ChartHelpTooltip',
  components: { },
  data() {
    return {};
  },
  watch: { },
  methods: { },
});

</script>
